import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("fs_token");
  if (t && !cfg.headers.Authorization) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e?.response?.status === 401 && !String(e?.config?.url || "").startsWith("/library")) {
      localStorage.removeItem("fs_token");
    }
    return Promise.reject(e);
  }
);

export const customerAuth = () => {
  const t = localStorage.getItem("fs_customer_token");
  return t ? { headers: { Authorization: `Bearer ${t}` } } : {};
};

export const fileUrl = (key) => (key ? `${API}/files/${key}` : "");

export default api;
